import React, { useEffect } from 'react';
import withRouter from '../Common/withRouter';
import { ConfigProvider, Layout } from 'antd';
import HeaderLayout from './Header';
import SidebarLayout from './SidebarLayout';
import { ThemeProvider, styled } from 'styled-components';
import { themecolor, darkthemecolors } from '../../src/config';
import { useTheme }  from '../Common/ThemeContext';
import { useLocation } from 'react-router-dom';

const { Content } = Layout;


// Define the StyleLayout styled component with conditional padding
const getPadding = (pathname) => {
  switch (pathname) {
    case '/dashboard':
      return '0 24px 0'; // example padding for a specific path
    default:
      return '140px 24px 0'; // default padding
  }
};

const StyleLayout = styled(Layout)`
  margin-left: ${themecolor.components.Menu.verticalSidebarWidth}px;
  position: relative;
  padding: ${(props) => getPadding(props.pathname)};

  .ant-breadcrumb {
    ol {
      justify-content: end;
    }
  }

  @media screen and (max-width: 768px) {
    margin-left: 0;
  }
`;

const LayoutComponents = ({ children }) => {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();

  const handleToggleMode = () => {
    toggleTheme();
  };
  let position = useLocation();

  useEffect(() => {
    document.body.classList.add("dashboard-view");
    document.body.classList.remove("public-view");

    return () => {
      document.body.classList.remove("dashboard-view");
    };
  }, []);
  

  return (
    <React.Fragment>
      <ThemeProvider theme={theme === 'dark' ? darkthemecolors : themecolor}>
        <ConfigProvider theme={theme === 'dark' ? darkthemecolors : themecolor}>
          <SidebarLayout theme={theme} />
          <Layout style={{ minHeight: '100vh' }} className={`${position.pathname === '/dashboard' ? 'dashboard_main_layout' : 'common_main_layout'}`}>
            <HeaderLayout darkMode={theme} handleToggleMode={handleToggleMode} />
            <StyleLayout id='antLayoutContent' pathname={location.pathname}>
              <Content>
                {children}
              </Content>
            </StyleLayout>
            {/* <FooterLayout /> */}
          </Layout>
        </ConfigProvider>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default withRouter(LayoutComponents);
